import Navbar from './components/Navbar';
import Demo from './components/Demo';

import './App.css';

function App() {
    return (
        <div>
            <Navbar />
            <Demo />
        </div>
    );
}

export default App;
